module.exports = __webpack_public_path__ + "img/lv20.b1c88c53.png";